import React, { Component } from 'react';
import { Map, Marker } from 'react-amap';
import './map.less';
import { debounce } from 'lodash';

import { AutoComplete, Spin, Cascader, Modal, Input } from 'antd';

let AMAP_KEY = 'fe7fa6ecf21c258e971edbf0fb945819', VERSION = '1.4.11';

export default class MapModel extends Component {

    constructor(props) {
        super(props);
        let a = {
            latitude: '39.909361',
            longitude: '116.48187',
            name: '华贸写字楼3座建国路79号',
            address: '北京市朝阳区'
        }
        let location = this.props.location ? this.props.location : a
        console.log('location', location)
        this.state = {
            location,
            longitude: location.longitude,
            latitude: location.latitude,
            address: '',
            markerPosition: {
                longitude: location.longitude,
                latitude: location.latitude,
            },
            center: {
                longitude: location.longitude,
                latitude: location.latitude,
            }
        }
    }

    componentDidMount() {

    }

    componentWillReceiveProps(newProps) {

    }

    componentWillUnmount() {

    }


    showModal = () => {
        this.setState({
            visible: true,
        });
    };


    emit = (key, item) => {
        if (typeof this.props[key] === 'function') {
            this.props[key](item);
        }
    }

    handleOk = e => {
        console.log(e);
        const { location } = this.state;
        if (!location) {
            return Modal.error({
                title: '提示',
                content: '请选择一个地址',
            });
        }
        this.emit('onChange', location);
    };



    handleCancel = e => {
        console.log(e);
        this.props.handleCancel && this.props.handleCancel()
    };

    onInputChange = e => {
        const address = e.target.value;
        this.setState(
            {
                address
            }
        );
    };

    render() {
        const { address, location, longitude, latitude, markerPosition, center } = this.state;
        let { visible } = this.props;
        if (!visible) return null
        const amapEvents = {
            created: (instance) => {
                let AMap = window.AMap;
                // react amap 自带的生命周期，在这里可以执行一些初始化操作
                AMap.plugin(['AMap.Autocomplete', 'AMap.PlaceSearch'], () => {
                    let autoOptions = {
                        // city: self.GmapData.city.name,			// 城市，默认全国 
                        // city: self.GmapData.addressComponent.citycode,
                        input: "tipinput"		// 使用联想输入的input的id
                    }
                    var autocomplete = new AMap.Autocomplete(autoOptions);
                    var placeSearch = new AMap.PlaceSearch({
                        input: 'tipinput',
                        pageSize: 10,
                        pageIndex: 1,
                        citylimit: true,    // 仅搜索本城市的地名
                    });
                    AMap.event.addListener(autocomplete, 'select', (e) => {
                        console.log(' e.poi', e.poi)
                        if (e.poi.location == '') {
                            getLocation(e.poi.district);
                            return
                        }
                        let poi = e.poi;
                        let { location } = this.state;
                        location.longitude = poi.location.lng
                        location.latitude = poi.location.lat
                        location.name = poi.name
                        location.level = poi.level
                        location.address = poi.district + poi.address
                        location.zoom = 16;
                        this.setState({
                            location,
                            markerPosition: {
                                longitude: poi.location.lng,
                                latitude: poi.location.lat
                            },
                            center: {
                                longitude: poi.location.lng,
                                latitude: poi.location.lat
                            }
                        })
                        // placeSearch.search(e.poi.name)
                        //TODO 针对选中的poi实现自己的功能
                        // if (e.poi.location == '') {
                        //     getLocation(e.poi.district);
                        //     return
                        // }
                        // self.GmapData.position.lng = e.poi.location.lng;
                        // self.GmapData.position.lat = e.poi.location.lat;
                        // self.GmapData.addressComponent = e.poi;

                        // getRGeocode();
                        // openInfo();
                    });

                    const getLocation = address => {
                        AMap.plugin('AMap.Geocoder', () => {
                            var geocoder = new AMap.Geocoder()
                            geocoder.getLocation(address, (status, result) => {
                                console.log('getLocation====status', status, result)
                                if (status === 'complete' && result.geocodes.length) {
                                    let { location } = this.state;
                                    var lnglat = result.geocodes[0].location;
                                    location.longitude = lnglat.lng
                                    location.latitude = lnglat.lat
                                    location.name = result.geocodes[0].formattedAddress
                                    location.address = result.geocodes[0].formattedAddress
                                    location.level = result.geocodes[0].level
                                    if (location.level == '市') {
                                        location.zoom = 10;
                                    }
                                    if (location.level == '省') {
                                        location.zoom = 7;
                                    }
                                    this.setState({
                                        location,
                                        markerPosition: {
                                            longitude: location.longitude,
                                            latitude: location.latitude
                                        },
                                        center: {
                                            longitude: location.longitude,
                                            latitude: location.latitude
                                        }
                                    })
                                }
                            });
                        })
                    }
                });

                // AMap.plugin(['AMap.Autocomplete', 'AMap.PlaceSearch'], () => {
                //     // 构造地点查询类
                //     this.doSearch = debounce(doSearch.bind(this), 500);
                //     let placeSearch = new AMap.PlaceSearch({
                //         pageSize: 10, // 单页显示结果条数
                //         pageIndex: 1, // 页码
                //         // city:, // 兴趣点城市
                //         citylimit: false,  // 是否强制限制在设置的城市内搜索
                //         map: mapInstance, // 展现结果的地图实例
                //         // panel: "panel", // 结果列表将在此容器中进行展示。
                //         autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
                //     });
                //     AMap.event.addListener(placeSearch, "selectChanged", (e) => {
                //         console.log('e', e.selected.data);
                //         this.setState({
                //             current: e.selected.data
                //         })
                //         mapInstance.setZoomAndCenter(16, [e.selected.data.location.lng, e.selected.data.location.lat]) // 设置中心点
                //     })
                //     // 经纬度查询
                //     if (Array.isArray(this.props.point)) {
                //         placeSearch.searchNearBy('', this.state.point, 500, (status, result) => {
                //             console.log('result1', status, result)
                //             if (status === 'complete') {
                //                 this.setState({
                //                     searchResult: result.poiList.pois,
                //                     current: result.poiList.pois[0]
                //                 })
                //             } else {
                //                 this.setState({
                //                     searchResult: [],
                //                     current: null
                //                 })
                //             }
                //         })
                //     } else {
                //         // 关键字查询
                //         // console.log('this.state.address', this.state.address)
                //         this.doSearch(location.name)
                //     }
                //     function doSearch(value) {
                //         if (this.state.searchResult.length) {
                //             this.setState({
                //                 searchResult: [],
                //             });
                //         }
                //         if (value) {
                //             placeSearch.search(value, (status, result) => {
                //                 console.log('result3', this.state.address, status, result)
                //                 if (status === 'complete') {
                //                     this.setState({
                //                         searchResult: result.poiList.pois,
                //                         current: result.poiList.pois[0]
                //                     })

                //                 } else {
                //                     this.setState({
                //                         searchResult: [],
                //                         current: null
                //                     })
                //                 }
                //             });
                //         }
                //     }

                // });
            },
            click: (e) => {
                console.log('ee', e)
            }
        }
        const plugins = [
            'OverView',
            'MapType',
            'Scale'
        ]
        return (
            <Modal
                className='mapModel'
                title="请选择商家位置"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                centered={true}
            >
                <div className={'search'}>
                    <Input value={address} onChange={this.onInputChange.bind(this)} placeholder='请输入关键字' allowClear id='tipinput' />
                </div>
                <Map zoom={location.zoom || 16} events={amapEvents} useAMapUI={true} plugins={plugins} center={center} amapkey={AMAP_KEY} version={VERSION} >
                    <Marker position={markerPosition} />
                </Map>
            </Modal>
        )
    }

}